<script>
  import Lenker from '../lenke/lenker.svelte'
  import { kategorier } from '../../stores/kategorier'

  export let slug

  $: kategori = $kategorier.find((k) => k.slug === slug)
</script>

<Lenker lenker={kategori.lenker} trackingId="lenker-{kategori.slug}" />
